import { render, staticRenderFns } from "./PatrolsDataIndex.vue?vue&type=template&id=6325f4ab&scoped=true&"
import script from "./PatrolsDataIndex.vue?vue&type=script&lang=js&"
export * from "./PatrolsDataIndex.vue?vue&type=script&lang=js&"
import style0 from "./PatrolsDataIndex.vue?vue&type=style&index=0&id=6325f4ab&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6325f4ab",
  null
  
)

export default component.exports